import { jsx as _jsx } from "react/jsx-runtime";
import { CustomizeModalText } from "./CustomizeModal-types";
import { LoadingButton } from "@mui/lab";
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["SUBMIT"] = "submit";
    ButtonTypes["BUTTON"] = "button";
})(ButtonTypes || (ButtonTypes = {}));
/**
 * A button component that dynamically changes its type and text based on the quantity prop.
 * If quantity > 0 then an assignment is being customized so we need to submit the form.
 * If quantity == 0 then an assignment is being removed so we need to bypass the form submit in case the form is invalid.
 *
 * @component
 * @param {boolean} isValid - Indicates if the form is valid
 * @param {number} quantity - The quantity of items
 * @param {() => void} onClick - The onClick handler to bypass normal form submission for assignment removal
 */
export const CustomizeSubmitBtn = ({ isValid, quantity, onClick }) => {
    const type = quantity > 0 ? ButtonTypes.SUBMIT : ButtonTypes.BUTTON;
    const buttonText = quantity > 0 ? CustomizeModalText.CONFIRM : CustomizeModalText.REMOVE_MEAL;
    return (_jsx(LoadingButton, Object.assign({ color: "primary", variant: "contained", disabled: !isValid && quantity > 0, sx: { width: { xx: "100%", sm: "163px" }, height: "40px" }, type: type, form: type === ButtonTypes.SUBMIT ? "customize-form" : "", onClick: type === ButtonTypes.BUTTON ? onClick : undefined }, { children: buttonText })));
};
